/* @flow */

import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Item, Button } from 'semantic-ui-react';
import { getEditComponent } from 'edito/plugin';

type Props = {
  mode: CatalogRenderingMode,
  block: EditorialBlock,
  onSave: (block: EditorialBlock) => void,
  onCancel: () => void,
};

type State = {
  diff: EditorialBlock,
  canSubmit: boolean,
};

class EditBlockItem extends Component {
  props: Props;
  state: State;

  constructor(props: Props) {
    super(props);

    this.state = {
      canSubmit: true,
      diff: props.block,
    };
  }

  componentWillReceiveProps(nextProps: Props) {
    if (nextProps.block !== this.props.block) {
      this.setState({
        diff: nextProps.block,
      });
    }
  }

  componentDidMount() {
    if (this.state.diff.isNew) {
      let element = ReactDOM.findDOMNode(this.item);

      // TODO: timeout to remove if children does not mutate their state (or does not have one) when they mount
      // Here timeout is set because some children use ProgressiveImage Component
      setTimeout(() => {
        element.scrollIntoView({ block: 'end' });
      }, 200);
    }
  }

  serializeContent = (diff: EditorialBlock) => {
    this.setState({
      diff,
    });
  };

  onCanSubmitChanged = (value: boolean) => {
    this.setState({ canSubmit: value });
  };

  renderContent() {
    const { mode } = this.props;
    const { diff } = this.state;

    const content = getEditComponent(diff);
    if (content === null) {
      console.warn(`Unknown edit block type ${diff.template}. Cannot render`);
      return null;
    }

    return React.cloneElement(content, {
      mode,
      onCanSubmitChanged: this.onCanSubmitChanged,
      onSerialize: this.serializeContent,
    });
  }

  render() {
    const { onSave, onCancel } = this.props;
    const { diff, canSubmit } = this.state;

    const save = () => onSave(diff);

    return (
      <div
        className="ui item"
        ref={ref => {
          this.item = ref;
        }}
      >
        <Item.Content>
          {this.renderContent()}
          <Item.Extra>
            <Button
              type="button"
              onClick={save}
              disabled={!canSubmit}
              primary
              floated="right"
              icon="check"
              content="Valider"
              labelPosition="right"
            />
            <Button
              type="button"
              onClick={onCancel}
              icon="chevron left"
              labelPosition="left"
              content="Annuler"
              floated="right"
            />
          </Item.Extra>
        </Item.Content>
      </div>
    );
  }
}

export default EditBlockItem;



// WEBPACK FOOTER //
// ./src/modules/edito/components/EditBlockItem.js